interface Window {
    // eslint-disable-next-line
    doLabelPrint(requestNo: string, requestOn: string, receiptUser: string, classificationName: string, storagePeriod: string, specimenReturn: number, count: number): Promise<any>
}
declare const window: Window

/**
 * 検体ラベル印刷サービス
 */
export default class LabelPrintService {
    /** インスタンス */
    private static _instance: LabelPrintService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new LabelPrintService();
        }
        return this._instance;
    }

    /**
     * 検体ラベルの印刷
     * @param requestNo
     * @param requestOn 
     * @param receiptUser 
     * @param classificationName 
     * @param storagePeriod 
     * @param specimenReturn
     * @param count 
     */
    // eslint-disable-next-line
    public async print(requestNo: string, requestOn: string, receiptUser: string, classificationName: string, storagePeriod: string, specimenReturn: number, count: number): Promise<any> {
        return await window.doLabelPrint(requestNo, requestOn, receiptUser, classificationName, storagePeriod, specimenReturn, count)
    }

}
